import { Page } from "../../../../../-components/Page"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { ColumnLayout } from "../../../-components/column-layout"
import { Text } from "@mantine/core"
import { useRouter } from "@tanstack/react-router"
import { ContractTrackingCard } from "@/components/contracts/ContractTrackingCard"
import { ContractConfirmationsCard } from "@/components/contracts/ContractConfirmationsCard"
import { ContractDatesCard } from "@/components/contracts/ContractDatesCard"
import { ContractFieldsCard } from "@/components/contracts/ContractFieldsCard"
import { ContractEngagementsCard } from "@/components/contracts/ContractEngagementsCard"
import { ContractDetailsCard } from "@/components/contracts/ContractDetailsCard"
import { PersonName } from "@components/PersonName"

export function ContractDetailsPage({ contractId }: { contractId: number }) {
  const { data: contract } = useSuspenseQueryGet(
    "/api/Contracts/GetContractDetails",
    { id: contractId }
  )

  const productionActivities = contract.engagements.flatMap((engagement) => ({
    productionTitle: engagement.production,
    contractDates: engagement.contractDates,
  }))

  const router = useRouter()

  React.useEffect(() => {
    router.invalidate()
  }, [contract])

  return (
    <Page
      crumbOverride={() => (
        <Text fz="xl" fw={"bold"}>
          {contract.contractTypeName}{" "}
          <PersonName personId={contract.personId} />
        </Text>
      )}
    >
      <ColumnLayout>
        <ContractDetailsCard contract={contract} />
        <ContractEngagementsCard engagements={contract.engagements} />
        <ContractFieldsCard fieldsGrouped={contract.contractFields} />
        {productionActivities.length > 0 &&
          productionActivities.some(
            (productionActivitie) =>
              productionActivitie.contractDates.length > 0
          ) && <ContractDatesCard data={productionActivities} />}
        <ContractConfirmationsCard confirmations={contract.confirmations} />
        <ContractTrackingCard contractTrackings={contract.contractTrackings} />
      </ColumnLayout>
    </Page>
  )
}
